import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ContractService } from '../../_services';
import { ContractBase } from "./contract.base";

@Component({
    selector: 'contract-detail',
    template: require('./contract-detail.template.html'),
    encapsulation: ViewEncapsulation.None
})
export class ContractDetailComponent extends ContractBase implements OnInit {

    constructor(
        protected readonly contractService: ContractService) {
        super(contractService);
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-detail.component.ts